export default __webpack_public_path__ + "static/media/3.d5a16bb5.jpg";